import { render, staticRenderFns } from "./moneyIn.vue?vue&type=template&id=0bfd7c06&scoped=true"
import script from "./moneyIn.vue?vue&type=script&lang=js"
export * from "./moneyIn.vue?vue&type=script&lang=js"
import style0 from "./moneyIn.vue?vue&type=style&index=0&id=0bfd7c06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfd7c06",
  null
  
)

export default component.exports